import { create } from "zustand";

import { apiCall } from "../../../utils/apiCall";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";

export const CorporationStore = create((set, get) => ({
  CorporationDetails: [],
  CorporationDetailsForMasters: [],
  isSaveCorporationLoading: false,
  isFetchCorporationDetailsLoading: false,
  isFetchAllCorporationsLoading: false,
  fetchCorporationDetailsError: null,
  EditData: null,
  error: null,
  success: null,

  setEditData: (data) => {
    set({ EditData: data });
  },

  // Updated fetchCorporationDetails to accept filter parameters
  fetchCorporationDetails: async () => {
    set({ isFetchCorporationDetailsLoading: true });
    try {
      const CorporationDetails = await apiCall({
        url: `${API_BASE_URL1}MasterCreate/GetALLCorporation`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const activeCorporations = (CorporationDetails?.data || []).filter(
        (corp) => corp?.isActive === true || corp?.isActive === "true"
      );

      set({
        CorporationDetailsForMasters:CorporationDetails.data,
        CorporationDetails: activeCorporations,
        isFetchCorporationDetailsLoading: false,
        success: "Corporations fetched successfully.",
      });
    } catch (error) {
      set({
        fetchCorporationDetailsError: error.message,
        isFetchCorporationDetailsLoading: false,
      });
    }
  },

  saveCorporationDetails: async (corporationData, isUpdate = false) => {
    set({ isSaveCorporationLoading: true });
    try {
      const url = isUpdate
        ? `${API_BASE_URL1}MasterCreate/UpdateCorporation`
        : `${API_BASE_URL1}MasterCreate/AddCorporation`;
      const method = isUpdate ? "put" : "post";

      const res = await apiCall({
        url,
        method,
        data: corporationData,
        token: localStorage.getItem("token"),
      });

      set({
        isSaveCorporationLoading: false,
      });
      get().fetchCorporationDetails();
      return { status: "success", data: res };
    } catch (error) {
      set({ error: error.message, isSaveCorporationLoading: false });
      throw error;
    }
  },

  // fetch categories
  categories: [],
  isFetchCategoriesLoading: false,

  fetchCategories: async () => {
    set({ isFetchCategoriesLoading: true });
    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}MasterCreate/ALLCategory`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({
        categories: Array.isArray(response) ? response : (response.data || []),
        isFetchCategoriesLoading: false,
      });
    } catch (error) {
      set({ isFetchCategoriesLoading: false });
    }
  },

  // fetch LE types
  leTypes: [],
  isFetchLeTypesLoading: false,

  fetchLeTypes: async () => {
    set({ isFetchLeTypesLoading: true });
    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}MasterDetails/GetLETypes`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      console.log("LE Types Response:", response);
      set({
        leTypes: Array.isArray(response) ? response : (response.data || []),
        isFetchLeTypesLoading: false,
      });
    } catch (error) {
      set({ isFetchLeTypesLoading: false });
    }
  },

  // fetch corporation accoerding to users
  UserCorporations: [],
  isFetchUserCorporationsLoading: false,

  fetchUserCorporations: async () => {
    set({ isFetchUserCorporationsLoading: true });
    try {
      const UserCorporationDetails = await apiCall({
        url: `${API_BASE_URL1}MasterCreate/GetMappedCorporations`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({
        UserCorporations: UserCorporationDetails.data,
        isFetchUserCorporationsLoading: false,
        success: "User Corporations fetched successfully.",
      });
    } catch (error) {
      set({
        isFetchUserCorporationsLoading: false,
      });
    }
  },
}));
